import * as Sentry from "@sentry/react"
import posthog from "posthog-js"

const SENTRY_DSN =
  "https://0470527044fccdaf4e36644859b0530a@o4506575947890688.ingest.us.sentry.io/4506575948939264"

const POSTHOG_API_KEY = "phc_smPS27PnytquIJQeH2UKUoR6cOuLMCsGiyNr8lAVwWi"
const POSTHOG_HOST = "https://eu.i.posthog.com"

export function initAnalytics() {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.VITE_APP_ENV,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })

  posthog.init(POSTHOG_API_KEY, {
    api_host: POSTHOG_HOST,
  })
}

export function identifyUser(user: {
  id: string
  email?: string | null
  firstName?: string | null
  lastName?: string | null
}) {
  Sentry.setUser({ id: user.id, email: user.email ?? undefined })

  posthog.identify(user.id, {
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
  })
}

export function resetUser() {
  Sentry.setUser(null)
  posthog.reset()
}

export function captureError(
  error: unknown,
  context?: {
    tags?: Record<string, string>
    extra?: Record<string, unknown>
  },
) {
  Sentry.captureException(error, {
    tags: context?.tags,
    extra: context?.extra,
  })

  posthog.captureException(error as Error, {
    ...context?.tags,
    ...context?.extra,
  })
}

export function trackEvent(
  eventName: string,
  properties?: Record<string, any>,
) {
  posthog.capture(eventName, properties)
}

export { Sentry }
